import React, {useEffect, useState} from "react";
import '../../css/web/AdminTaxListModal.css';
import commonClose from '../../assets/img/commonClose.png'
import {useNavigate} from "react-router-dom";

function AdminCtItemModify({
                               checkedCtList,
                               closeModifyPopupShow,
                               modifyCustomItem
                           }) {

    const [hsCodeNmList, setHsCodeNmList] = useState([]);
    const [hsCodeEnNmList, setHsCodeEnNmList] = useState([]);
    const [hsCodeList, setHsCodeList] = useState([]);
    const [mcNmList, setMcNmList] = useState([]);
    const [mcAddressList, setMcAddressList] = useState([]);
    const [mcZipcodeList, setMcZipcodeList] = useState([]);

    // 최초 렌더링 시 checkedCtList 기준으로 초기값 세팅
    useEffect(() => {
        if (checkedCtList && checkedCtList.length > 0) {
            setHsCodeNmList(checkedCtList.map(item => item.hsCodeNm || ""));
            setHsCodeEnNmList(checkedCtList.map(item => item.hsCodeEnNm || ""));
            setHsCodeList(checkedCtList.map(item => item.hsCode || ""));
            setMcNmList(checkedCtList.map(item => item.mcNm || ""));
            setMcAddressList(checkedCtList.map(item => item.mcAddress || ""));
            setMcZipcodeList(checkedCtList.map(item => item.mcZipcode || ""));
        }
    }, [checkedCtList]);

    // 각 인풋에 대응하는 변경 핸들러
    const handleCodeNmChange = (index, value) => {
        const updated = [...hsCodeNmList];
        updated[index] = value;
        setHsCodeNmList(updated);
    };

    const handleCodeEnNmChange = (index, value) => {
        const updated = [...hsCodeEnNmList];
        updated[index] = value;
        setHsCodeEnNmList(updated);
    };

    const handleCodeChange = (index, value) => {
        const updated = [...hsCodeList];
        updated[index] = value;
        setHsCodeList(updated);
    };

    const handleMcNmChange = (index, value) => {
        const updated = [...mcNmList];
        updated[index] = value;
        setMcNmList(updated);
    };

    const handleMcAddressChange = (index, value) => {
        const updated = [...mcAddressList];
        updated[index] = value;
        setMcAddressList(updated);
    };

    const handleMcZipcodeChange = (index, value) => {
        const updated = [...mcZipcodeList];
        updated[index] = value;
        setMcZipcodeList(updated);
    };

    const [omissionInputMsg, setOmissionInputMsg] = useState("");
    const validData = () => {
        const hasEmpty =
            hsCodeNmList.some(val => val.trim() === "") ||
            hsCodeEnNmList.some(val => val.trim() === "") ||
            hsCodeList.some(val => val.trim() === "");

        if (hasEmpty) {
            setOmissionInputMsg(true);
            return;
        }

        setOmissionInputMsg(false);

        // 최신 인풋 데이터를 반영한 checked 데이터 구성
        const updatedList = checkedCtList.map((item, index) => ({
            ...item,
            hsCodeNm: hsCodeNmList[index],
            hsCodeEnNm: hsCodeEnNmList[index],
            hsCode: hsCodeList[index],
            mcNm: mcNmList[index],
            mcAddress: mcAddressList[index],
            mcZipcode: mcZipcodeList[index],
        }));

        // A컴포넌트의 콜백 호출
        modifyCustomItem(updatedList);
    };

    return (
        <div className="modal-overlay font-t-cont">
            <div className="ct-modal-content">
                <div className="modal-header">
                    <h3>품목 코드 수정</h3>
                    <img
                        className="close-icon"
                        src={commonClose}
                        alt="close"
                        onClick={closeModifyPopupShow}
                    />
                </div>

                <div className="modal-body">
                    <div className="table-container">
                        <table className="tax-table">
                            <thead>
                            <tr>
                                <th style={{width: '10%'}}>번호</th>
                                <th style={{width: '25%'}}>
                                    <p>품목명</p>
                                    <p>제조사명</p>
                                </th>
                                <th style={{width: '40%'}}>
                                    <p>품목명(English)</p>
                                    <p>제조사주소</p>
                                </th>
                                <th style={{width: '25%'}}>
                                    <p>HS CODE</p>
                                    <p>제조사우편번호</p>
                                </th>
                            </tr>
                            </thead>
                            <tbody>
                            {checkedCtList && checkedCtList.map((item, i) => (
                                <tr key={i} style={{borderBottom: "1px solid #eee"}}>
                                    <td style={{verticalAlign: "middle", textAlign: "center", width: "50px"}}>
                                        {i + 1}
                                    </td>

                                    <td className="pd-10" colspan="3">
                                        <div style={{
                                            display: "flex",
                                            flexDirection: "column",
                                            gap: "10px",
                                            padding: "10px 0"
                                        }}>
                                            {/* 첫 번째 줄: 품목명, 영문명, HS코드 */}
                                            <div style={{display: "flex", gap: "10px", alignItems: "center"}}>
                                                <input
                                                    value={hsCodeNmList[i] || ""}
                                                    onChange={(e) => handleCodeNmChange(i, e.target.value)}
                                                    className="admin-input-line wd-150 ht-35 p-l-5"
                                                    type="text"
                                                    placeholder="품목명"
                                                />
                                                <input
                                                    value={hsCodeEnNmList[i] || ""}
                                                    onChange={(e) => handleCodeEnNmChange(i, e.target.value)}
                                                    className="admin-input-line wd-200 ht-35 p-l-5"
                                                    type="text"
                                                    placeholder="품목명(영문)"
                                                />
                                                <input
                                                    value={hsCodeList[i] || ""}
                                                    onChange={(e) => handleCodeChange(i, e.target.value)}
                                                    className="admin-input-line wd-150 ht-35 p-l-5"
                                                    type="text"
                                                    placeholder="HS Code"
                                                />
                                            </div>

                                            {/* 두 번째 줄: 제조사명, 제조사주소, 우편번호 */}
                                            <div style={{display: "flex", gap: "10px", alignItems: "center"}}>
                                                <input
                                                    value={mcNmList[i] || ""}
                                                    onChange={(e) => handleMcNmChange(i, e.target.value)}
                                                    className="admin-input-line wd-150 ht-35 p-l-5"
                                                    type="text"
                                                    placeholder="제조사명"
                                                />
                                                <input
                                                    value={mcAddressList[i] || ""}
                                                    onChange={(e) => handleMcAddressChange(i, e.target.value)}
                                                    className="admin-input-line wd-360 ht-35 p-l-5"
                                                    type="text"
                                                    placeholder="제조사 주소"
                                                />
                                                <input
                                                    value={mcZipcodeList[i] || ""}
                                                    onChange={(e) => handleMcZipcodeChange(i, e.target.value)}
                                                    className="admin-input-line wd-150 ht-35 p-l-5"
                                                    type="text"
                                                    placeholder="우편번호"
                                                />
                                            </div>
                                        </div>
                                    </td>
                                </tr>
                            ))}
                            </tbody>
                        </table>
                    </div>
                </div>

                <div className="ct-modal-footer">
                    <div className="JoinErrorMsg">
                        {omissionInputMsg &&
                            <p className="JoinErrMsg" style={{color: "#EE5757"}}>모든 양식을 입력해주세요</p>
                        }
                    </div>
                    <button
                        onClick={() => validData(hsCodeNmList, hsCodeList)}
                        className="filter-complete-btn"
                    >
                        수정완료
                    </button>
                </div>
            </div>
        </div>
    )
}

export default AdminCtItemModify
